/**
 * Revenue By Type Chart
 *
 * Bar chart showing revenue breakdown by project type.
 */

import ChartContainer from '@/components/charts/ChartContainer';
import BarChart from '@/components/charts/BarChart';
import type { RevenueByType } from '../types';

interface RevenueByTypeChartProps {
  data?: RevenueByType[];
  loading?: boolean;
}

const TYPE_LABELS: Record<string, string> = {
  installation: 'Installation',
  shipping: 'Shipping',
  calibration: 'Calibration',
};

export function RevenueByTypeChart({ data, loading }: RevenueByTypeChartProps) {
  const chartData = data?.map((item) => ({
    name: TYPE_LABELS[item.type] || item.type,
    completed: item.completed_amount,
    pending: item.total_amount - item.completed_amount,
  })) ?? [];

  const hasData = chartData.length > 0 && chartData.some((d) => d.completed > 0 || d.pending > 0);

  return (
    <ChartContainer
      title="Revenue by Project Type"
      loading={loading}
      height={250}
    >
      {hasData ? (
        <BarChart
          data={chartData}
          height={250}
          xAxisKey="name"
          series={[
            { dataKey: 'completed', name: 'Completed', color: '#22c55e' },
            { dataKey: 'pending', name: 'In Progress', color: '#f59e0b' },
          ]}
          stacked
          showLegend
        />
      ) : (
        <div className="flex items-center justify-center h-full text-muted-foreground text-sm">
          No revenue data available
        </div>
      )}
    </ChartContainer>
  );
}
